



















































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import GlobalMixins from '@/mixins'

import { bus } from '@/main'
import ContentImage from '@/components/content/Image.vue'
import ContentText from '@/components/content/Text.vue'
import ContentVideo from '@/components/content/Video.vue'

const onClickaway = require('vue-clickaway')
const draggable = require('vuedraggable')

@Component({
	directives: {
		onClickaway: onClickaway.directive
	},
	components: {
		ContentImage,
		ContentText,
		ContentVideo,
		draggable
	}
})
export default class Question extends GlobalMixins {
	@Prop({ required: true }) question!: any

	infoOpen: boolean = false
	infoOpenedRecently: boolean = false
	draggableOptions: { [key: number]: { id: number, text: string } } = []
	currentlyDragging: boolean = false
	formInputValues: { [key: string]: string } = {}
	formInitComplete: boolean = false
	nextQuestionButtonDisabled: boolean = false
	
	get options(): any[] {
		if (this.question.randomize) {
			if (this.$store.getters.randomizedOptions[this.$store.getters.currentScreen - 1]) {
				return this.$store.getters.randomizedOptions[this.$store.getters.currentScreen - 1]
			} else {
				const randomizedOptions = this.question.options.sort(() => Math.random() - 0.5)
				const allRandomizedOptions = this.$store.getters.randomizedOptions

				for (let i = 0; i < (this.$store.getters.currentScreen - 1); i++) {
					if (!allRandomizedOptions[i]) {
						allRandomizedOptions.push(undefined)
					}
				}

				allRandomizedOptions[this.$store.getters.currentScreen - 1] = randomizedOptions

				this.$store.dispatch('setRandomizedOptions', allRandomizedOptions)

				return this.$store.getters.randomizedOptions[this.$store.getters.currentScreen - 1]
			}
		} else {
			return this.question.options
		}	
	}
	get correctAnswerOfMultipleChoice() {
		let answer = {
			id: -1,
			index: -1,
			text: ''
		}

		if (this.options && this.question.type === 'multiple-choice') {
			this.options.forEach((option, index) => {
				if (option.id === this.question.answer.value) {
					answer = {
						id: option.id,
						index: (index + 1),
						text: option.text
					}
				}
			})
		}		

		return answer
	}
	get multipleChoiceIncorrectMessage(): string {
		let userChosenLetter: string | false = ''

		this.options.forEach((option, index) => {
			if (option.id === this.$store.getters.userChoices[this.$store.getters.currentScreen - 1]) {
				userChosenLetter = this.numberToAlphabetLetter(index + 1)
			}
		})

		return `Je koos ${userChosenLetter}. Het juiste antwoord is ${this.numberToAlphabetLetter(this.correctAnswerOfMultipleChoice.index)}.`
	}
	get allFormFieldsFilledIn(): boolean {
		let allFormFieldsFilledIn: boolean = true
		
		for (let key in this.formInputValues) {
			if (this.formInputValues[key] === '') {
				allFormFieldsFilledIn = false
			}
		}

		return allFormFieldsFilledIn
	}
	get nextButtonDisabled(): boolean {
		let nextButtonDisabled: boolean = false

		if (this.question.type === 'form') {
			nextButtonDisabled = !this.allFormFieldsFilledIn
		} else {
			nextButtonDisabled = (this.$store.getters.userChoices[this.$store.getters.currentScreen - 1] === undefined || this.$store.getters.userChoices[this.$store.getters.currentScreen - 1].length === 0)
		}

		return nextButtonDisabled
	}

	@Watch('infoOpen')
	onInfoOpenChange(): void {
		if (this.infoOpen) {
			ga('send', 'event', {
				anonymizeIp: true,
				eventCategory: 'Info',
				eventAction: 'Opened',
				eventLabel: `Vraag ${this.$store.getters.currentScreen}`,
			})
			this.infoOpenedRecently = true

			setTimeout(() => {
				this.infoOpenedRecently = false
			}, 400)
		}
	}
	@Watch('draggableOptions', { deep: true })
	onDraggableOptionsChange(): void {
		this.recordAnswer('draggable', this.draggableOptions)
	}
	@Watch('formInputValues', { deep: true })
	onFormInputValuesChange(): void {
		if (this.formInitComplete) {
			this.$store.dispatch('setFormInputValues', { questionId: this.$store.getters.currentScreen, answers: this.formInputValues })
			this.recordAnswer('form', this.formInputValues)
		}
	}

	getComponentByType(type: string): any {
		switch (type) {
			case 'image':
				return ContentImage
				break
			case 'text':
				return ContentText
				break
			case 'video':
				return ContentVideo
				break
		}
	}
	closeInfoPanel(): void {
		if (!this.infoOpenedRecently) {
			this.infoOpen = false
		}
	}
	recordAnswer(type: string, answer: boolean | number | { [key: string]: string } | { [key: number]: { id: number, text: string } }): void {
		let userChoices = this.$store.getters.userChoices

		if (type === 'yes-no' || type === 'multiple-choice' || type === 'draggable') {
			if (userChoices[this.$store.getters.currentScreen - 1] === undefined) {
				userChoices.push(answer)
			} else {
				userChoices.splice(this.$store.getters.currentScreen - 1, 1, answer)
			}
		} else if (type === 'tags') {
			let userChosenTags: any = []

			if (userChoices[this.$store.getters.currentScreen - 1] === undefined) {
				userChosenTags.push(answer)
				userChoices.push(userChosenTags)
			} else {
				userChosenTags = userChoices[this.$store.getters.currentScreen - 1]

				if (userChosenTags.indexOf(answer) === -1) {
					userChosenTags.push(answer)
				} else {
					userChosenTags.splice(userChosenTags.indexOf(answer), 1)
				}

				userChoices.splice(this.$store.getters.currentScreen - 1, 1 , userChosenTags)
			}
		} else if (type === 'form') {
			if (this.allFormFieldsFilledIn) {
				if (userChoices[this.$store.getters.currentScreen - 1] === undefined) {
					userChoices.push(answer)
				} else {
					userChoices.splice(this.$store.getters.currentScreen - 1, 1, answer)
				}
			} else {
				if (userChoices[this.$store.getters.currentScreen - 1] === undefined) {
					userChoices.push({})
				} else {
					userChoices.splice(this.$store.getters.currentScreen - 1, 1, {})
				}
			}
		}
		
		this.$store.dispatch('setUserChoices', userChoices)
		
		if (type === 'yes-no' || type === 'multiple-choice') {
			this.infoOpen = false

			this.$router.push({ name: 'answer' })
		}
	}
	goToAnswer(): void {
		let userChoicesOfScreen = this.$store.getters.userChoices[this.$store.getters.currentScreen - 1]
		let canGoToNextScreen: boolean = false
		
		if (this.question.type === 'form') {
			if (this.allFormFieldsFilledIn) {
				this.infoOpen = false

				canGoToNextScreen = true
			}

		} else {
			if (userChoicesOfScreen !== undefined && userChoicesOfScreen.length !== 0) {
				this.infoOpen = false

				canGoToNextScreen = true
			}
		}

		if (canGoToNextScreen) {
			if (this.question.answer) {
				this.$router.push({ name: 'answer', params: { questionId: JSON.stringify(this.$store.getters.currentScreen) } })
			} else {
				this.goToNextQuestion()
			}
		}
	}
	goToNextQuestion(): void {
		if (!this.nextQuestionButtonDisabled) {
			this.nextQuestionButtonDisabled = true

			if (this.$store.getters.currentScreen === this.$store.getters.data.questions.length) {
				bus.$emit('userOnResultScreen', true)

				this.$router.push({ name: 'results' })
			} else {
				this.$router.push({ name: 'question', params: { questionId: JSON.stringify(this.$store.getters.currentScreen + 1) } })
			}
		}
	}
	numberToAlphabetLetter(id: number): string | false {
		let s = ''
		let t;

		while (id > 0) {
			t = (id - 1) % 26;
			s = String.fromCharCode(65 + t) + s;
			id = (id - t)/26 | 0;
		}

		s.toUpperCase()

		return s || false;
	}

	mounted() {
		bus.$on('closeInfo', () => {
			this.infoOpen = false
		})
		bus.$on('onAnswerScreenChange', (fromSameQuestion: boolean) => {
			if (fromSameQuestion) {
				this.nextQuestionButtonDisabled = false
			} else {
				setTimeout(() => {
					this.nextQuestionButtonDisabled = false
				}, 330)
			}

			setTimeout(() => {
				window.scrollTo(0, 0)
			}, fromSameQuestion ? 210 : 330)
		})

		if (this.question.type === 'draggable') {
			let userChoicesOfScreen = this.$store.getters.userChoices[this.$store.getters.currentScreen - 1]

			this.draggableOptions = this.options

			if (userChoicesOfScreen !== undefined && userChoicesOfScreen.length !== 0) {
				this.draggableOptions = userChoicesOfScreen
			}
		} else if (this.question.type === 'form') {
			let formDataFound: boolean = false

			this.$store.getters.formInputValues.forEach((formData: { questionId: number, answers: { [key: string]: string } }) => {
				if (formData.questionId === this.$store.getters.currentScreen) {
					formDataFound = true
					this.formInputValues = formData.answers
				}
			})

			if (!formDataFound) {
				this.question.value.forEach((questionPart: string | {
					type: 'number' | 'text',
					size: string,
					name: string,
					placeholder: string
				} | {
					type: 'select',
					size: string,
					options: { [key: number]: {
						label: string,
						value: string,
						selected?: boolean
					} },
					name: string
				}) => {
					if (typeof questionPart !== 'string') {
						if (questionPart.type === 'select') {
							(<any>questionPart.options).forEach((option: { label: string, value: string, selected?: boolean }) => {
								if (option.selected) {
									Vue.set(this.formInputValues, questionPart.name, option.value)
								}
							})
						} else {
							Vue.set(this.formInputValues, questionPart.name, '')
						}
					}
				})
			}

			Vue.nextTick(() => {
				this.formInitComplete = true
			})
		}

		this.$store.dispatch('setQuestionVisited', (this.$store.getters.currentScreen - 1))

		document.addEventListener('keydown', e => {
			if (e.keyCode === 27) {
				this.infoOpen = false
			}
		})
	}
	beforeDestroy() {
		bus.$off('closeInfo')
		bus.$off('onAnswerScreenChange')
	}
}
